export default __webpack_public_path__ + "locales/de/Ldap.json?hash=0c953cdb278c6223aaf36a56996781db";